var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.98,
    height: 23.1,
    viewBox: "0 0 20.98 23.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-verified"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3,6A5.3,5.3,0,0,1,20.9,6,5.3,5.3,0,0,1,10.3,6ZM11,6a4.48,4.48,0,0,0,4.5,4.5A4.55,4.55,0,0,0,20,6a4.55,4.55,0,0,0-4.5-4.5A4.48,4.48,0,0,0,11,6Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1,12.1l-1-1a.45.45,0,0,1,0-.5.45.45,0,0,1,.5,0l1,1a.45.45,0,0,1,0,.5.37.37,0,0,1-.3.1C21.2,12.3,21.1,12.2,21.1,12.1Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,14.9h0a3.76,3.76,0,0,1-3.7-3.7A3.69,3.69,0,0,1,6.6,7.5a3.63,3.63,0,0,1,3.7,3.7,3.9,3.9,0,0,1-3.7,3.7ZM3.9,11.3a2.56,2.56,0,0,0,2.5,2.6h.2a2.6,2.6,0,0,0-.1-5.2A2.52,2.52,0,0,0,3.9,11.3Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,22.1a2.83,2.83,0,0,1,0-5,7.58,7.58,0,0,1,7.7,0,2.83,2.83,0,0,1,0,5,7,7,0,0,1-3.8,1.1A7.39,7.39,0,0,1,2.8,22.1Zm-.5-2.5a2,2,0,0,0,1,1.6,6.32,6.32,0,0,0,6.5,0,1.94,1.94,0,0,0,1-1.6,2,2,0,0,0-1-1.6,6.32,6.32,0,0,0-6.5,0A2,2,0,0,0,2.3,19.6Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_65",
    "data-name": "Capa 65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,7.7,13.6,6.3a.49.49,0,1,1,.7-.7l1,1,2.4-2.4a.49.49,0,0,1,.7.7L15.7,7.6c-.1.1-.2.1-.4.1S15.1,7.8,15,7.7Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_66",
    "data-name": "Capa 66"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.3,19a.6.6,0,1,1,0,1.2H14A.6.6,0,0,1,14,19Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,16.4a.61.61,0,0,1,0,1.2H13.9a.61.61,0,0,1,0-1.2Z",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVerified);
export default __webpack_public_path__ + "static/media/user-verified.40116fa42bc306a00df5b56be15a5a7d.svg";
export { ForwardRef as ReactComponent };